/* eslint-disable no-lonely-if */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MdBackspace, MdClose } from 'react-icons/md';
import { evaluate } from 'mathjs';
import './Calculator.scss';
import AppIconButton from './app-icon-button/AppIconButton';

function Calculator({ onClose }) {
  const [input, setInput] = useState('');
  const [result, setResult] = useState('');
  const inputRef = useRef(null);
  const windowRef = useRef(null);
  const [position, setPosition] = useState({ x: 500, y: 100 });
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    const inputElement = inputRef.current;
    inputElement.scrollLeft = inputElement.scrollWidth;
  }, [input]);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const handleClick = (buttonValue) => {
    const operators = ['+', '-', '*', '/', '%'];

    if (operators.includes(buttonValue)) {
      if (operators.includes(input.slice(-1))) {
        setInput(input.slice(0, -1) + buttonValue);
      } else {
        setInput(input + buttonValue);
      }
    } else {
      if (input === '0') {
        setInput(buttonValue);
      } else {
        setInput(input + buttonValue);
      }
    }
  };

  const handleClear = () => {
    setInput('');
    setResult('');
  };
  const handleChange = (e) => {
    const value = e.target.value;
    if (/^[0-9+\-*/.%]*$/.test(value)) {
      setInput(value);
    }
  };

  const handleCalculatePercent = () => {
    try {
      const newInput = input.slice(0, -1);
      const processedInput = newInput.replace(/(\d+)%/g, '($1/100)');
      const percentValue =
        (Number(evaluate(processedInput).toFixed(2)) * 1) / 100;
      setResult(Number(percentValue.toFixed(2)));
    } catch (error) {
      setResult('Error');
    }
  };

  const handleCalculate = () => {
    if (input.charAt(input.length - 1) === '%') {
      handleCalculatePercent();
      return;
    }
    try {
      const processedInput = input.replace(/(\d+)%/g, '($1/100)');
      setResult(Number(evaluate(processedInput).toFixed(2)));
    } catch (error) {
      setResult('Error');
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleCalculate();
    }
  };
  const handleBackspace = () => {
    setInput(input.slice(0, -1));
  };

  return (
    <div
      ref={windowRef}
      className="floating-window"
      style={{
        top: `${position.y}px`,
        left: `${position.x}px`,
        position: 'absolute',
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div className="floating-window-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Calculator</h4>
        <AppIconButton
          onClick={onClose}
          variant="transparent"
          className="p-0 d-flex fs-4"
        >
          <MdClose />
        </AppIconButton>
      </div>
      <div className="floating-window-content">
        <div className="calculator">
          <div className="display">
            <input
              type="text"
              className="input"
              value={input}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              ref={inputRef}
            />

            <div className="result">{result}</div>
          </div>
          <div className="buttons">
            {[
              '7',
              '8',
              '9',
              '+',
              '4',
              '5',
              '6',
              '-',
              '1',
              '2',
              '3',
              '*',
              '0',
              '.',
              '%',
              '/',
              'C',
            ].map((btn, index) => (
              <button
                key={index}
                onClick={
                  btn === 'C' || btn === 'AC'
                    ? handleClear
                    : () => handleClick(btn)
                }
              >
                {btn}
              </button>
            ))}
            <button onClick={handleBackspace}>
              <MdBackspace />
            </button>
            <div onClick={handleCalculate} className="equal-amount">
              =
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Calculator.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Calculator;
